import { render, staticRenderFns } from "./privte.vue?vue&type=template&id=0ec98d40&scoped=true&"
import script from "./privte.vue?vue&type=script&lang=js&"
export * from "./privte.vue?vue&type=script&lang=js&"
import style0 from "./privte.vue?vue&type=style&index=0&id=0ec98d40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec98d40",
  null
  
)

export default component.exports